import { useContext, useRef } from "react";
import "./contact.css";
import "../home/home.css";
import { ThemeContext } from "../../context.js";
import emailjs from "@emailjs/browser";
import { Box, Grid } from "@mui/material";
import { motion } from "framer-motion";
import Footer from "../Footer.js";
import FAQSection from "../Pages/FAQSection.jsx";

const Contact = () => {
  const refForm = useRef();

  const theme = useContext(ThemeContext);
  const darkMode = theme.state.darkMode;

  const handleSubmit = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        "service_82syxy4",
        "template_hgpwda5",
        refForm.current,
        "vj6yFHCVjbcr_L5P8"
      )
      .then(
        (result) => {
          // console.log(result.text);
          alert("Message has been successfully sent!");
          window.location.reload(false);
        },
        (error) => {
          alert("Message failed to send, please try again");
          // console.log(error.text);
        }
      );
  };

  const animationc = {
    initial: { opacity: 0, y: -100 },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: -100 },
  };

  return (
    <Grid container width="100%" className="c">
      <Box
        width="100%"
        display="flex"
        flexDirection={{ xs: "column", lg: "row" }}
        paddingTop={{ xs: "80px", md: "70px", lg: "97px", xl: "108px" }}
        paddingLeft={{ xs: "10px", md: "10px", lg: "20px", xl: "30px" }}
        paddingRight={{ xs: "10px", md: "10px", lg: "50px", xl: "70px" }}
      >
        <Box
          width={{ xs: "auto", lg: "70%", xl: "60%" }}
          marginLeft="auto"
          marginRight="auto"
          // marginTop={{ xs: "80px", md: "70px", lg: "97px", xl: "103px" }}
        >
          <FAQSection />
        </Box>
        <Box
          width={{ xs: "auto", lg: "50%", xl: "40%" }}
          padding={{
            xs: "18px 5px 12px 5px",
            lg: "8px 55px 5px 35px",
            xl: "10px 55px 15px 35px",
          }}
          // margin="auto"
          marginLeft="auto"
          marginRight="auto"
          marginTop={{ xs: "80px", md: "0px" }}
          // border={{ xs: "none", lg: "2px solid #d4af37" }}
          borderRadius={{ xs: "none", lg: "20px" }}
          boxShadow={{ xs: "none", md: "0 0 20px #d4af37" }}
          className="contact1"
        >
          <span
            className="c-desc"
            style={{
              color: darkMode ? "#fff" : "#a5a5a5",
            }}
          >
            Contact Me.
          </span>
          <form ref={refForm} onSubmit={handleSubmit}>
            <motion.div
              variants={animationc}
              initial="initial"
              animate="animate"
              exit="exit"
              transition={{ duration: 0.7 }}
            >
              <input
                style={{
                  backgroundColor: darkMode ? "#41403F" : "#EEE8AC",
                  color: darkMode && "#fff",
                }}
                type="text"
                placeholder="Name"
                name="user_name"
                required
              />
            </motion.div>
            <motion.div
              variants={animationc}
              initial="initial"
              animate="animate"
              exit="exit"
              transition={{ duration: 0.9 }}
            >
              <input
                style={{
                  backgroundColor: darkMode ? "#423F40" : "#E8DE9D",
                  color: darkMode && "#fff",
                }}
                type="text"
                placeholder="Email"
                name="user_email"
                required
              />
            </motion.div>

            <motion.div
              variants={animationc}
              initial="initial"
              animate="animate"
              exit="exit"
              transition={{ duration: 1 }}
            >
              <input
                style={{
                  backgroundColor: darkMode ? "#333" : "#D8CA7F",
                  color: darkMode && "#fff",
                }}
                type="text"
                placeholder="Subject"
                name="user_subject"
                required
              />
            </motion.div>

            <motion.div
              variants={animationc}
              initial="initial"
              animate="animate"
              exit="exit"
              transition={{ duration: 1.5 }}
            >
              <textarea
                style={{
                  backgroundColor: darkMode ? "#2B2A29" : "#D4C070",
                  color: darkMode && "#fff",
                }}
                rows="5"
                placeholder="Your Message"
                name="message"
                required
              />
            </motion.div>

            <div
              style={{
                width: "100%",
                display: "flex",
              }}
            >
              <button
                className="btn-home"
                style={{
                  marginLeft: "auto",
                  marginRight: "auto",
                  paddingTop: "12px",
                  paddingBottom: "12px",
                  paddingLeft: "28px",
                  paddingRight: "28px",
                  borderRadius: "5px",
                  border: darkMode ? "2px solid #ffffff" : "2px solid #a5a5a5",
                  backgroundColor: "transparent",
                  color: darkMode ? "#ffffff" : "#a5a5a5",
                  cursor: "pointer",
                  textTransform: "none",
                }}
              >
                Submit
              </button>
            </div>
          </form>
        </Box>
      </Box>
      <Footer />
    </Grid>
  );
};

export default Contact;
